import { render } from "./EmailMessage.vue?vue&type=template&id=5bfa4906&scoped=true"
import script from "./EmailMessage.vue?vue&type=script&lang=js"
export * from "./EmailMessage.vue?vue&type=script&lang=js"

import "./EmailMessage.vue?vue&type=style&index=0&id=5bfa4906&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfa4906"]])

export default __exports__